// src/i18n/es/users.ts

export const users = {
  name: 'Usuario |||| Usuarios',
  
  fields: {
    id: 'ID',
    username: 'Usuario',
    email: 'Email',
    name: 'Nombre',
    firstName: 'Nombre',
    lastName: 'Apellidos',
    role: 'Rol',
    password: 'Contraseña',
    temporaryPassword: 'Contraseña temporal',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmPassword: 'Confirmar contraseña',
    status: 'Estado',
    createdAt: 'Fecha de creación',
    updatedAt: 'Última actualización',
    lastLogin: 'Último acceso',
    lastLoginAt: 'Último acceso',
    hotelId: 'Instalación',
    groupId: 'Grupo',
    assignedGroups: 'Grupos asignados',
    assignedHotels: 'Instalaciones asignadas',
    assignments: 'Asignaciones',
    allAccess: 'Acceso total',
    noAssignments: 'Sin asignaciones',
    groupsCount: '%{smart_count} grupo |||| %{smart_count} grupos',
    hotelsCount: '%{smart_count} instalación |||| %{smart_count} instalaciones',
    isActive: 'Activo',
    isInactive: 'Inactivo',
  },
  
  roles: {
    SuperAdmin: 'Super Administrador',
    superAdmin: 'Super Administrador',
    Admin: 'Administrador',
    admin: 'Administrador',
    GroupAdmin: 'Administrador de Grupo',
    groupAdmin: 'Administrador de Grupo',
    HotelAdmin: 'Administrador de Instalación',
    hotelAdmin: 'Administrador de Instalación',
    Viewer: 'Visor',
    viewer: 'Visor',
    Receptionist: 'Recepcionista',
    receptionist: 'Recepcionista',
    User: 'Usuario',
  },
  
  list: {
    title: 'Usuarios',
    search: 'Buscar por nombre o email',
    loading: 'Cargando usuarios...',
    empty: 'No hay usuarios',
  },
  
  create: {
    title: 'Crear Usuario',
    subtitle: 'Complete los datos del nuevo usuario',
  },
  
  edit: {
    title: 'Editar Usuario',
    subtitle: 'Modifique los datos del usuario',
  },
  
  sections: {
    basic_info: 'Información básica',
    assignments: 'Asignaciones',
    assignments_subtitle: 'Seleccione las instalaciones o grupos a los que el usuario tendrá acceso',
    change_password: 'Cambiar contraseña',
    reset_password: 'Restablecer contraseña',
  },
  
  menu: {
    change_password: 'Cambiar Contraseña',
    profile: 'Perfil',
    settings: 'Configuración',
    account: 'Cuenta',
  },
  
  actions: {
    change_password: 'Cambiar contraseña',
    reset_password: 'Restablecer contraseña',
    activate: 'Activar',
    deactivate: 'Desactivar',
    add_group_hotels: 'Incluir todos',
    impersonate: 'Suplantar identidad',
  },
  
  validation: {
    email_required: 'El email es obligatorio',
    email_invalid: 'Email inválido',
    name_required: 'El nombre es obligatorio',
    firstName_required: 'El nombre es obligatorio',
    lastName_required: 'Los apellidos son obligatorios',
    name_min_length: 'Debe tener al menos 2 caracteres',
    name_max_length: 'No puede exceder 100 caracteres',
    password_required: 'La contraseña es obligatoria',
    password_min_length: 'La contraseña debe tener al menos 8 caracteres',
    temporary_password_helper: 'Mínimo 8 caracteres. El usuario deberá cambiarla en su primer inicio de sesión',
    external_login_helper: 'El usuario iniciará sesión con su proveedor de identidad corporativo',
    current_password_required: 'La contraseña actual es obligatoria',
    confirm_password_required: 'Debe confirmar la nueva contraseña',
    passwords_not_match: 'Las contraseñas no coinciden',
    role_required: 'El rol es obligatorio',
    role_helper: 'Seleccione el nivel de acceso del usuario',
    groups_helper: 'Grupos a los que el usuario tendrá acceso',
    hotels_helper: 'Instalaciones a las que el usuario tendrá acceso',
    groups_required_for_role: 'Debe asignar al menos un grupo para este rol',
    hotels_required_for_role: 'Debe asignar al menos una instalación para este rol',
    select_group_first: 'Seleccione un grupo',
    group_hotels_added: 'Se ha añadido %{count} instalación del grupo |||| Se han añadido %{count} instalaciones del grupo',
    group_no_hotels: 'El grupo seleccionado no tiene instalaciones',
  },
  
  messages: {
    session_expired: 'Sesión expirada',
    password_changed: 'Contraseña cambiada correctamente',
    password_change_error: 'Error al cambiar la contraseña',
    password_change_success: 'Contraseña cambiada correctamente',
    invalid_current_password: 'La contraseña actual es incorrecta',
    password_requirements: 'La contraseña debe tener al menos 8 caracteres',
    user_created: 'Usuario creado correctamente',
    user_updated: 'Usuario actualizado correctamente',
    user_deleted: 'Usuario eliminado correctamente',
    create_success: 'Usuario creado correctamente',
    create_error: 'Error al crear el usuario',
    update_success: 'Usuario actualizado correctamente',
    update_error: 'Error al actualizar el usuario',
    delete_success: 'Usuario eliminado correctamente',
    delete_error: 'Error al eliminar el usuario',
    delete_confirm: '¿Eliminar usuario?',
    user_not_found: 'Usuario no encontrado',
    email_already_exists: 'Ya existe un usuario con ese email',
    superadmin_access: 'Los Super Administradores tienen acceso a todas las instalaciones y grupos',
    temporary_password_info: 'Se establecerá una contraseña temporal. El usuario deberá cambiarla en su primer inicio de sesión.',
    external_login_info: 'El usuario no tendrá contraseña propia. Iniciará sesión con su proveedor de identidad corporativo.',
    use_external_login: 'Inicio de sesión con su proveedor de identidad corporativo',
    password_reset_success: 'Contraseña temporal establecida correctamente',
    password_reset_error: 'Error al restablecer la contraseña',
    self_role_change: 'No puede cambiar su propio rol',
    self_deactivation: 'No puede desactivar su propia cuenta',
    superadmin_management_denied: 'Solo los gestores de staff pueden gestionar SuperAdministradores',
    activate_success: 'Acceso a Insight activado correctamente',
    deactivate_confirm: '¿Desactivar el acceso a Insight?',
    deactivate_content: '%{name} dejará de poder entrar en Insight. Su cuenta y su acceso a otras aplicaciones no cambian. Puede volver a activarlo cuando quiera.',
    deactivate_success: 'Acceso a Insight desactivado correctamente',
    account_disabled: 'La cuenta de este usuario está desactivada para todas las aplicaciones. Para volver a habilitarla, contacte con el soporte de Roommatik.',
    user_deactivated: 'Este usuario está desactivado. Actívelo antes de editarlo.',
    activate_error: 'Error al activar el usuario',
    saving_user: 'Guardando usuario...',
    activating_user: 'Activando usuario...',
    deactivating_user: 'Desactivando usuario...',
  },
};

export default users;